import { Link } from 'react-router-dom';
import SearchBar from '@/components/feature/SearchBar';
import { hotMovies, typeLabel } from '@/utils/media';

const CATEGORY_NAV = [
  { label: '电影', to: '/category/movie', icon: 'ri-film-line' },
  { label: '电视剧', to: '/category/tv', icon: 'ri-live-line' },
  { label: '热门推荐', to: '/category/hot', icon: 'ri-fire-line' },
  { label: '影视资讯', to: '/news', icon: 'ri-newspaper-line' },
];

export default function HomeSidebar() {
  const ranking = hotMovies(6);

  return (
    <aside className="flex flex-col gap-5">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="mb-3 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-search-2-line text-primary-600" />
          站内搜索
        </h2>
        <SearchBar size="md" />
        <p className="mt-2 text-[11px] text-foreground-400">支持按影视名称、类型与资讯标题搜索</p>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="mb-3 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-apps-2-line text-primary-600" />
          分类导航
        </h2>
        <div className="grid grid-cols-2 gap-2">
          {CATEGORY_NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="flex items-center gap-2 rounded-md border border-background-200 px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
            >
              <i className={`${item.icon} text-primary-500`} />
              {item.label}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="mb-3 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-accent-500" />
          热门排行榜
        </h2>
        <ol className="flex flex-col">
          {ranking.map((movie, index) => (
            <li key={movie.id}>
              <Link
                to={`/detail/${movie.id}`}
                className="group flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-100 cursor-pointer"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                    index < 3
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                    {movie.title}
                  </p>
                  <p className="text-[11px] text-foreground-400">
                    {typeLabel(movie.type)} · {movie.region}
                  </p>
                </div>
                <span className="shrink-0 text-xs font-semibold text-accent-600">
                  {movie.rating.toFixed(1)}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-lg border border-primary-200 bg-primary-50 p-4">
        <h2 className="mb-2 flex items-center gap-2 font-heading text-base font-bold text-primary-800">
          <i className="ri-information-line" />
          关于 91爱爱
        </h2>
        <p className="text-xs leading-relaxed text-primary-900/80">
          91爱爱聚焦最新影视资源与影视资讯，为影视爱好者提供便捷的查找、浏览与资讯阅读体验，电脑与手机端均可流畅访问。
        </p>
        <Link
          to="/about"
          className="mt-3 inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-700 transition-colors hover:text-accent-600 cursor-pointer"
        >
          了解更多
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>
    </aside>
  );
}